/**
 * Group summary callback for the inventory table.
 * The inventory table grouped rows are the primary interaction points for users to manage their asset tag bulk selections.
 */
import React from 'react';
import { Text } from 'core/components';
import AssetTagInventoryModel from 'app/stores/assetTags/AssetTagInventoryModel';
import AssetTagInventoryCollection from 'app/stores/assetTags/AssetTagInventoryCollection';
import LabelRenderer from './LabelRenderer';
import valueRenderer from './valueRenderer';
import currentAssetsRenderer from './currentAssetsRenderer';
import TargetValueSelector from './TargetValueSelector';
import TargetAssetSelector from './TargetAssetSelector';
import ActionRenderer from './ActionRenderer';

interface Props {
  groupKey: string;
  group: AssetTagInventoryModel[];
}

function groupSummaryLookup({ groupKey: tagId, group }: Props) {
  const [model] = group;
  const collection = model.collection as unknown as AssetTagInventoryCollection | null;

  if (!collection) {
    return null;
  }

  return {
    groupType: 'summary',
    label: <LabelRenderer group={group} />,
    description: (
      <Text title={model.get('description')} ellipsis>
        {model.get('description')}
      </Text>
    ),
    valueEdited: valueRenderer({ group }),
    current_assets: currentAssetsRenderer({ collection, group }),
    target_value: <TargetValueSelector collection={collection} tagId={tagId} />,
    asset_name: <TargetAssetSelector collection={collection} tagId={tagId} />,
    actions: <ActionRenderer collection={collection} tagId={tagId} group={group} />
  };
}

export default groupSummaryLookup;
